import { HTTP_API_V2 } from '../../http-common'

export default {
  state: {
    loadedStatistics2: []
  },
  getters: {
    loadedStatistics2 (state) {
      return state.loadedStatistics2
    }
  },
  mutations: {
    setLoadedStatistics2 (state, payload) {
      state.loadedStatistics2 = payload
    },
    clearLoadedStatistics2 (state) {
      state.loadedStatistics2 = []
    }
  },
  actions: {
    fetchStatistics2 ({ commit }, payload) {
      commit('clearError')
      commit('setLoading', true)
      commit('setLoadedStatistics2', [])
      return new Promise((resolve, reject) => {
        HTTP_API_V2.get('statistics', {
          params: {
            mac: payload.mac || null,
            initial_date: payload.initial_date || null,
            initial_hour: payload.initial_hour || null,
            final_date: payload.final_date || null,
            final_hour: payload.final_hour || null
          }
        })
        .then(result => {
          const uniqueSortedData = Array.from(
            new Map(
              result.data
                .sort((a, b) => a.age - b.age)
                .map(item => [item.age, item])
            ).values()
          )
          commit('setLoadedStatistics2', uniqueSortedData)
          resolve(uniqueSortedData)
        })
        .catch(err => {
          commit('setError', err)
          reject(err)
        })
        .finally(() => {
          commit('setLoading', false)
        })
      })
    },
    clearLoadedStatistics2 ({ commit }) {
      commit('clearLoadedStatistics2')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/statistic2/index.js